import * as React from 'react';

import { useDeviceCondition } from '../../../../../../hooks';
import { AnimationElement } from '../../../../../common/Animation';
import * as styles from './Layout.css';

interface ILayoutProps {
  price: React.ReactNode;
  packages: React.ReactNode;
  recommendedPackages: React.ReactNode;
  recommendedPackagesPaymentStatus: React.ReactNode;
}

export const Layout = ({ price, packages, recommendedPackages, recommendedPackagesPaymentStatus }: ILayoutProps) => {
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  return (
    <div className={rootStyle}>
      <AnimationElement layout="position" className={styles['publication']}>
        <div>{price}</div>
      </AnimationElement>

      {packages && (
        <AnimationElement layout="position" className={styles.packages}>
          {packages}
        </AnimationElement>
      )}

      {recommendedPackages && (
        <AnimationElement layout="position" className={styles['recommendedPackages']}>
          {recommendedPackages}
        </AnimationElement>
      )}

      {recommendedPackagesPaymentStatus && (
        <AnimationElement layout="position" className={styles['recommendedPackagesPaymentStatus']}>
          {recommendedPackagesPaymentStatus}
        </AnimationElement>
      )}
    </div>
  );
};
